export default "__VITE_ASSET__Dsf_kcf0__"